import { BaseRequestDynamic } from '../../core/models/request';

export class LoginUserRequest extends BaseRequestDynamic {
  constructor(public UserName: string, public Password: string) {
    super('Sport', 'LoginUser');
  }
}
